import React from "react";
import "./newsletter.css"

const Newsletter = () => {
    return (
        <div className="center-wrapper newsletter">
        
            <p>My beautiful readers! I am so happy you're here. To show my gratitude to you for being part of this journey, I'm giving everyone who signs up for my newsletter the never-before-published first chapter of my upcoming novel, The Voice of the Sea! Know that I appreciate each and every one of you, and am abundantly aware that these dreams could never come true without you. With all my heart, thank you. <br/><br/>
            Click <a href="https://blogspot.us20.list-manage.com/subscribe?u=2c473d9d403d8ea03a3f382d3&id=9a4978eedf">here </a>to sign up for the newsletter and get your free gift! The newsletter will only be sent out when there is exciting information to share about a book coming out. <br/>Your information will remain confidential, and never be sold or used to pester you. </p>
        </div>
    )
}

export default Newsletter;